import React from "react";

import { Box, Button, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { BackArrowIcon } from "../../components/ui-elements/svg-icons";
import { useNavigate } from "react-router-dom";
import PrivacyContent from "../../components/account/privacy-content";

const Privacy = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <>
      {/* Header Menu */}
      <Box
        sx={{
          background: theme.palette.background.paper,
        }}
      >
        <Box sx={{ width: "80%", mx: "auto" }}>
          <Stack
            direction={"row"}
            spacing={1}
            alignItems={"center"}
            sx={{ py: 2 }}
          >
            <Button onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </Button>
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              Privacy policy
            </Typography>
          </Stack>

          <PrivacyContent />
        </Box>
      </Box>
    </>
  );
};

export default Privacy;
